module.exports = __webpack_public_path__ + "img/bingo_ball-89.a508b215.png";